(ns common.intelligence.common
  (:require
   [clojure.string :as string]
   [common.util :as cu]))

(defonce enrich-attributes
         {:entity.type/company [;; reverse priority
                                :company/crunchbase-company
                                ;:company/fullcontact-company
                                :company/intelligence-company
                                :company/clearbit-company]
          :entity.type/person  [:person/crunchbase-person
                                ;:person/fullcontact-person
                                :person/intelligence-person
                                :person/clearbit-person]
          :entity.type/oppo    [:oppo/intelligence-oppo]})

(defn enrichment-entities
  [entity]
  (let [enriching-attributes (get enrich-attributes (:entity/type entity))]
    (->> enriching-attributes
         (keep (fn [a]
                 (let [intelligence-entity (get entity a)]
                   (when-not (cu/blank-value? (:intelligence-data/raw-data intelligence-entity))
                     intelligence-entity))))
         (seq))))

(defn enrich-entity
  [entity & [logger]]
  (let [entity-type (:entity/type entity)
        enriching-attributes (get enrich-attributes entity-type)]
    entity                                                  ;;TODO crunchbase issues - uncomment code below when crunchbase search and syncing work properly
    ;;  see also:
    (if-not enriching-attributes
      entity
      (let [data-ns (when (keyword? entity-type)
                      (name entity-type))
            data-namespaces #{data-ns}
            asset? (= entity-type :entity.type/company)     ;;TODO add other asset-types when applicable
            data-namespaces (if asset?
                              #{data-ns "asset"}
                              #{data-ns})
            enriching-entities
            (->> enriching-attributes
                 (map (fn [ic-entity]
                        (when ic-entity
                          (->> ic-entity
                               (get entity)
                               (map (fn [[k v]]
                                      (when (some #{(namespace k)} data-namespaces)
                                        [k v])))
                               (remove (fn [o]
                                         (or (nil? o)
                                             (empty? o))))
                               (into {})))))
                 (remove nil?))]
        (if (or (nil? enriching-entities)
                (not (coll? enriching-entities))
                (empty? enriching-entities))
          entity
          (merge
           (apply merge enriching-entities)
           (->> entity
                (map (fn [[k v]]
                       (when (and v
                                  (not (and (string? v)
                                            (empty? (string/trim v))))) ;; do not override intelligence with empty values
                         [k v])))
                (into {}))))))))
